import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import PageHero from "../components/PageHero";
import CTASection from "../components/CTASection";
import AnimatedCounter from "../components/AnimatedCounter";
import { VALUES, TIMELINE, STATS } from "../lib/data";
import { fadeUp, stagger, staggerChild } from "../lib/motion";

export default function About() {
  return (
    <>
      <PageHero
        eyebrow="About"
        title="A solely run, proud to be local, website creation business"
        subtitle="SolkSites was started with a simple idea: that small and medium businesses deserve the same quality of design and technology as the world's biggest brands — without the ego, the jargon or the six-month timelines."
      >
        
      </PageHero>
      

      <section className="section" data-testid="about-story">
        <div className="container-page grid lg:grid-cols-12 gap-16 items-center">
          <motion.div {...fadeUp} className="lg:col-span-6">
            <div className="rounded-[24px] overflow-hidden border border-slate-200 dark:border-slate-800">
              <img src="/IMG_5262.jpg" alt="Charlie Solk" className="w-full h-[480px] object-cover" loading="lazy" />
            </div>
          </motion.div>
          <motion.div {...fadeUp} className="lg:col-span-6">
            <p className="eyebrow">My story</p>
            <h2 className="mt-4 text-3xl md:text-4xl font-extrabold tracking-tighter text-slate-900 dark:text-white">
              Passion for technology, put to work for businesses
            </h2>
            <div className="mt-6 space-y-4 text-lg text-slate-600 dark:text-slate-300 leading-relaxed">
              <p>Hi! My name's Charlie and I've always had a passion for technology since I was young, and as a younger person in our world, when I need to locate a business, my first port of call is always - website.</p>
              <p>As the world of online presences advances, small local businesses can end up at a disadvantages as online agencies push their prices even higher.</p>
              <p>My solution. A business with transparent costs, doesn't take more work than it can handle, and an owner you can always reach out to. This is SolkSites. Need something we don't offer, let us know. Confused why something is happening, book a call with us. Anything you need, we're here.</p>
            </div>
            <div className="flex gap-3 mt-4">
              <Link to="/contact" className="btn-primary">Say hello <ArrowUpRight className="h-4 w-4" /></Link>
              <Link to="/portfolio" className="btn-secondary">See our work</Link>
            </div>
          </motion.div>
        </div>
      </section>

      <section className="section bg-slate-950 text-white" data-testid="about-stats">
        <div className="container-page">
          <div className="grid gap-10 md:grid-cols-4">
            {STATS.map((s) => (
              <div key={s.label} className="border-l border-slate-800 pl-6">
                <p className="text-5xl md:text-6xl font-extrabold tracking-tighter"><AnimatedCounter value={s.value} suffix={s.suffix} /></p>
                <p className="mt-3 text-sm text-slate-400">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section" data-testid="about-values">
        <div className="container-page">
          <motion.div {...fadeUp} className="max-w-3xl">
            <p className="eyebrow">Our values</p>
            <h2 className="mt-4 text-3xl md:text-4xl font-extrabold tracking-tighter text-slate-900 dark:text-white">
              How we work — and what we won't compromise on.
            </h2>
          </motion.div>
          <motion.div {...stagger(0.08)} className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
            {VALUES.map((v, i) => (
              <motion.div key={v.title} {...staggerChild} className="card-surface p-7">
                <p className="text-sm font-semibold text-blue-600 dark:text-blue-400">0{i+1}</p>
                <h3 className="mt-3 text-lg font-semibold text-slate-900 dark:text-white">{v.title}</h3>
                <p className="mt-2 text-sm text-slate-600 dark:text-slate-400 leading-relaxed">{v.desc}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* <section className="section bg-white dark:bg-slate-950 border-y border-slate-100 dark:border-slate-900" data-testid="about-timeline">
        <div className="container-page">
          <motion.div {...fadeUp} className="max-w-3xl">
            <p className="eyebrow">Timeline</p>
            <h2 className="mt-4 text-3xl md:text-4xl font-extrabold tracking-tighter text-slate-900 dark:text-white">A short history.</h2>
          </motion.div>
          <div className="mt-14 relative">
            <div className="absolute left-3 md:left-1/2 top-0 bottom-0 w-px bg-slate-200 dark:bg-slate-800" aria-hidden="true" />
            <div className="space-y-12">
              {TIMELINE.map((item, i) => (
                <motion.div key={item.year} {...fadeUp} className="relative grid md:grid-cols-2 gap-8 items-start" data-testid={`timeline-${item.year}`}>
                  <div className={`md:pr-12 ${i % 2 === 0 ? "md:text-right" : "md:col-start-2 md:pl-12 md:pr-0"}`}>
                    <p className="text-sm font-semibold text-blue-600 dark:text-blue-400 tracking-widest">{item.year}</p>
                    <h3 className="mt-2 text-xl font-semibold text-slate-900 dark:text-white">{item.title}</h3>
                    <p className="mt-2 text-slate-600 dark:text-slate-400 leading-relaxed">{item.desc}</p>
                  </div>
                  <div className="absolute left-3 md:left-1/2 -translate-x-1/2 top-1 h-3 w-3 rounded-full bg-blue-600 ring-4 ring-white dark:ring-slate-950" />
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section> */}

      <CTASection />
    </>
    
  );
}
